import pl from "@locales/components/pl.json";
import en from "@locales/components/en.json";
export default {
  pl: pl,
  en: en,
};
